import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import SocialProof from "@/components/landing/SocialProof";
import Stats from "@/components/landing/Stats";
import HowItWorks from "@/components/landing/HowItWorks";
import HowWeWork from "@/components/landing/HowWeWork";
import ContractTiers from "@/components/landing/ContractTiers";
import TargetAudience from "@/components/landing/TargetAudience";
import Creators from "@/components/landing/Creators";
import Coverage from "@/components/landing/Coverage";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";
import BookingDialog from "@/components/landing/BookingDialog";
import { BookingDialogProvider } from "@/contexts/BookingDialogContext";

export default function Landing() {
  return (
    <BookingDialogProvider>
      <main data-testid="landing-page" className="bg-white text-[#0D3A35]">
        <Header />
        <Hero />
        <SocialProof />
        <Stats />
        <HowItWorks />
        <HowWeWork />
        <ContractTiers />
        <TargetAudience />
        <Creators />
        <Coverage />
        <Testimonials />
        <FAQ />
        <CTASection />
        <Footer />
        <BookingDialog />
      </main>
    </BookingDialogProvider>
  );
}
